import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { loadApplicationSettings } from "./api";
import { measurementConfiguration } from "./measurements";

export function useMeasurementSettings() {
  const settings = useQuery({
    queryKey: ["application-settings"],
    queryFn: loadApplicationSettings
  });
  const configuration = useMemo(
    () => measurementConfiguration(settings.data),
    [settings.data]
  );
  return { ...settings, configuration };
}
